import { ReactElement, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { StyledLink } from 'components/v2/Link'
import Modal from 'components/v2/Modal'
import Heading from 'components/v2/Heading'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from '@10xLabs/react-web/components/Table'
import { FormattedDateTime } from '@10xLabs/react-web/components/FormattedDateTime'
import { EmailStatus } from 'features/Bookings/components/EmailStatus'
import { GTBookingV2 } from 'gql/types.generated'
import { isEmpty } from 'lodash'

interface IBookingEmailsProps {
  booking: GTBookingV2
}

export const BookingEmails = ({ booking }: IBookingEmailsProps): TSFixMe => {
  const intl = useIntl()
  const [isModalOpen, setModalOpen] = useState(false)

  return (
    <div>
      {!isEmpty(booking.emailsSent) ? (
        <>
          <div>
            <EmailStatus status={booking.emailsSent.at(0)?.status} />
          </div>
          <div>
            <StyledLink onClick={(): TSFixMe => setModalOpen(true)}>{booking.emailsSent.length}</StyledLink>
          </div>
        </>
      ) : (
        0
      )}
      {!isEmpty(booking.emailsSent) && isModalOpen && (
        <Modal.Container large>
          <Modal.Header onClose={(): void => setModalOpen(false)}>
            <Heading.H5>
              <FormattedMessage id="bookings.emails.title" defaultMessage="Emails" />
            </Heading.H5>
          </Modal.Header>
          <Modal.Content>
            <TableContainer overflow>
              <Table>
                <Thead>
                  <Tr>
                    <Th>
                      <FormattedMessage id="dictionary.email" defaultMessage="Email" />
                    </Th>
                    <Th>
                      <FormattedMessage id="dictionary.date" defaultMessage="Date" />
                    </Th>
                    <Th>
                      <FormattedMessage id="dictionary.status" defaultMessage="Status" />
                    </Th>
                    <Th>
                      <FormattedMessage id="dictionary.reason" defaultMessage="Reason" />
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {booking.emailsSent.map((email, index): ReactElement => {
                    return (
                      <Tr key={index}>
                        <Td>{email.address}</Td>
                        <Td>
                          <FormattedDateTime intl={intl} date={email.updatedAt} />
                        </Td>
                        <Td>
                          <EmailStatus status={email.status} />
                        </Td>
                        <Td>{email.reason}</Td>
                      </Tr>
                    )
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </Modal.Content>
        </Modal.Container>
      )}
    </div>
  )
}
